import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { config } from '../../utils/config';
import { Input, Empty, Descriptions, Button, DatePicker , message } from 'antd'
import { Page, Crud, Upload } from '../../components'
export class SearchProduct extends Component {
  static propTypes = {
    gkproduct: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  componentDidMount() {
    const { productListParticularsIdActions, chooseCurrentProduct } = this.props.actions
    this.id = this.props.match.params.id;
    console.log(this.id)
    productListParticularsIdActions(this.id).then((res) => {
      console.log(res.data)
      chooseCurrentProduct(res.data)
    })
  }
  handleXkzImage = (e) => {
    const { actions } = this.props;
    if (e) {
      window.open(`${config.attachUrl}${e}`)
    } else {
      message.info('数据不存在');
    }
    
  }
  // 监督检验证书
  render() {
    const { currentProduct } = this.props.gkproduct
    if (currentProduct === null || currentProduct === undefined) {
      return <Empty />
    }
    return (
      <Page inner>
        <Descriptions bordered>
          <Descriptions.Item label="气瓶编号">{currentProduct.pid !== undefined || currentProduct.pid !== null ? currentProduct.pid : ''}</Descriptions.Item>
          <Descriptions.Item label="气瓶品种">{currentProduct.qpName !== undefined || currentProduct.qpName !== null ? currentProduct.qpName : ''}</Descriptions.Item>
          <Descriptions.Item label="气瓶型号">{currentProduct.typeName !== undefined || currentProduct.typeName !== null ? currentProduct.typeName : ''}</Descriptions.Item>
          <Descriptions.Item label="制造日期">{currentProduct.pdate !== undefined || currentProduct.pdate !== null ? currentProduct.pdate : ''}</Descriptions.Item>
          <Descriptions.Item label="公称容积(L)">{currentProduct.lifeSj !== undefined || currentProduct.lifeSj !== null ? currentProduct.lifeSj : ''}</Descriptions.Item>
          <Descriptions.Item label="公称压力(MPa)">{currentProduct.gzyl !== undefined || currentProduct.gzyl !== null ? currentProduct.gzyl : ''}</Descriptions.Item>
          <Descriptions.Item label="设计检验周期(年)">{currentProduct.jyzqSj !== undefined || currentProduct.jyzqSj !== null ? currentProduct.jyzqSj : ''}</Descriptions.Item>
          <Descriptions.Item label="制造单位">{currentProduct.unitname !== undefined || currentProduct.unitname !== null ? currentProduct.unitname : ''}</Descriptions.Item>

          <Descriptions.Item label="充装介质">{currentProduct.mediumname !== undefined || currentProduct.mediumname !== null ? currentProduct.mediumname : ''}</Descriptions.Item>
          <Descriptions.Item label="设计循环次数">{currentProduct.sLic !== undefined || currentProduct.sLic !== null ? currentProduct.sLic : ''}</Descriptions.Item>
          <Descriptions.Item label="制造许可证编号">{currentProduct.noLic !== undefined || currentProduct.noLic !== null ? currentProduct.noLic : ''}</Descriptions.Item>
          <Descriptions.Item label="安全阀制造单位">{currentProduct.dwAqf !== undefined || currentProduct.dwAqf !== null ? currentProduct.dwAqf : ''}</Descriptions.Item>
          <Descriptions.Item label="安全阀制造许可证编号">{currentProduct.licAqf !== undefined || currentProduct.licAqf !== null ? currentProduct.licAqf : ''}</Descriptions.Item>
          <Descriptions.Item label="安全阀门">{currentProduct.typeAqf !== undefined || currentProduct.typeAqf !== null ? currentProduct.typeAqf : ''}</Descriptions.Item>
          <Descriptions.Item label="截止阀制造单位">{currentProduct.dwJzf !== undefined || currentProduct.dwJzf !== null ? currentProduct.dwJzf : ''}</Descriptions.Item>
          <Descriptions.Item label="截止阀制造许可证编号">{currentProduct.licJzf !== undefined || currentProduct.licJzf !== null ? currentProduct.licJzf : ''}</Descriptions.Item>
          <Descriptions.Item label="截止阀型号">{currentProduct.typeJzf !== undefined || currentProduct.typeJzf !== null ? currentProduct.typeJzf : ''}</Descriptions.Item>
          <Descriptions.Item label="调压阀制造单位">{currentProduct.dwTyf !== undefined || currentProduct.dwTyf !== null ? currentProduct.dwTyf : ''}</Descriptions.Item>
          <Descriptions.Item label="调压阀制造许可证编号">{currentProduct.licTyf !== undefined || currentProduct.licTyf !== null ? currentProduct.licTyf : ''}</Descriptions.Item>
          <Descriptions.Item label="调压阀阀型号">{currentProduct.typeTyf !== undefined || currentProduct.typeTyf !== null ? currentProduct.typeTyf : ''}</Descriptions.Item>
          <Descriptions.Item label="经济阀制造单位">{currentProduct.dwJjf !== undefined || currentProduct.dwJjf !== null ? currentProduct.dwJjf : ''}</Descriptions.Item>
          <Descriptions.Item label="经济阀制造许可证编号">{currentProduct.licJjf !== undefined || currentProduct.licJjf !== null ? currentProduct.licJjf : ''}</Descriptions.Item>
          <Descriptions.Item label="经济阀型号">{currentProduct.typeJjf !== undefined || currentProduct.typeJjf !== null ? currentProduct.typeJjf : ''}</Descriptions.Item>
          {/**/}
          {/**/}

          <Descriptions.Item label="气瓶产品合格证">
            <a onClick={() => this.handleXkzImage(currentProduct.qphgzOssname)}>查看</a>
          </Descriptions.Item>
          <Descriptions.Item label="质量证明书">
            <a onClick={() => this.handleXkzImage(currentProduct.zlzmsOssname)}> 查看</a>
          </Descriptions.Item>
          <Descriptions.Item label="监督检验证书">
            <a onClick={() => this.handleXkzImage(currentProduct.zzjjzsOssname)}> 查看</a>
          </Descriptions.Item>
          <Descriptions.Item label="型式试验证书">
            <a onClick={() => this.handleXkzImage(currentProduct.xssyzsOssname)}>查看</a>

          </Descriptions.Item>
          <Descriptions.Item label="钢印标识">
            <a onClick={() => this.handleXkzImage(currentProduct.gypicOssname)}>查看</a>

          </Descriptions.Item>
          <Descriptions.Item label="气瓶电子标识">
            <a onClick={() => this.handleXkzImage(currentProduct.qpflagOssname)}>查看</a>
          </Descriptions.Item>

          <Descriptions.Item label="产品使用手册">
            <a onClick={() => this.handleXkzImage(currentProduct.mediumsheetOssname)}>查看</a>
          </Descriptions.Item>
          <Descriptions.Item label="产品数据表">
            <a onClick={() => this.handleXkzImage(currentProduct.qpDataFile)}>查看</a>
          </Descriptions.Item>
          <Descriptions.Item label="产品附件">
            <a onClick={() => this.handleXkzImage(currentProduct.qpParamFile)}> 查看</a>
          </Descriptions.Item>
        </Descriptions>
      </Page>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    gkproduct: state.gkproduct,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchProduct);



// WEBPACK FOOTER //
// ./src/features/gkproduct/SearchProduct.js